export default "__VITE_ASSET__DiAu5PlS__"